
import FcmAccount from "./fcmAccount";
import fcmAccountsService from "./fcmAccountsService";
import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";

export class FcmAccountsLoaded extends Event {
    constructor(public fcmAccounts: FcmAccount[]) {
        super(FcmAccountsLoaded.EventName);
    }

    public static EventName: string = "FCM_ACCOUNTS_LOADED";
}

export function loadFcmAccounts(): ActionWithDispatch<FcmAccountsLoaded> {
    return function (dispatch) {
        return fcmAccountsService
            .listFcmAccounts()
            .then(fcmAccounts => dispatch(new FcmAccountsLoaded(fcmAccounts).toObject()));
    };
}